import { FC, ReactNode } from 'react'
import { useIntl } from 'react-intl'

import { Button } from '@pijma/crypto'

import { useToken } from '@hooks'
import styled from 'styled-components'

import { DarkBgClass } from '../../../../../generated/quicktype/Tokens'
import { appClose } from '../../../../helpers/route-utils'
import { H4 } from '../../../common/header/Headings'
import { IconNegative } from '../../../common/icons/IconNegative'
import { FlexBoxCenteredLayout } from '../../../common/layout/flex-box'
import { CaptionText500 } from '../../../common/text/BodyText'

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
`

const TitleWrapper = styled.div`
  margin-top: 16px;
  white-space: pre-wrap;
`

const TipWrapper = styled.div<DarkBgClass>`
  margin-top: 16px;
  margin-left: 42px;
  margin-right: 42px;
  white-space: pre-wrap;
`

const ButtonWrapper = styled.div`
  margin: 24px 0 16px 0;
`

interface IResultPage {
  title?: string
  tip?: ReactNode
  btnAction?: () => void
}

export const ErrorPage: FC<IResultPage> = ({ title, tip }) => {
  const intl = useIntl()
  const tokens = useToken()
  const closeWindow = appClose

  return (
    <FlexBoxCenteredLayout>
      <Container>
        <IconNegative />
        <TitleWrapper>
          <H4>{title ?? intl.formatMessage({ id: 'errorPage.title' })}</H4>
        </TitleWrapper>

        {tip ? (
          <TipWrapper {...tokens.color.font.light_bg}>
            <CaptionText500>{tip}</CaptionText500>
          </TipWrapper>
        ) : null}

        <ButtonWrapper>
          <Button
            width={'100%'}
            size={'m'}
            type={'primary'}
            onPress={() => closeWindow()}
          >
            {intl.formatMessage({ id: 'errorPage.button' })}
          </Button>
        </ButtonWrapper>
      </Container>
    </FlexBoxCenteredLayout>
  )
}
